import React from 'react';
import cn from 'classnames'; // to use global class name eg. classes from grid.css in public folder
import styles from './Totalcounts.scss';// to import local scss fle

const Totalcounts = () => (
  <div className={cn('row', styles.counts)}>
    <div className={cn('col s6 m3', styles.countsBody)}>
      <div className={styles.centerDiv}>
        <span className={styles.totalNumber} >135,199</span><br />
        <span className={styles.totalNumberText}>TWITTER FOLLOWERS</span><br />
        <span>
          <div className={styles.underline} />
        </span>
      </div>
    </div>
    <div className={cn('col s6 m3', styles.countsBody)}>
      <div className={styles.centerDiv}>
        <span className={styles.totalNumber} >898</span><br />
        <span className={styles.totalNumberText}>FOOTBALL COLLEGES AND UNIVERSITIES</span><br />
        <span>
          <div className={styles.underline} />
        </span>
      </div>
    </div>
    <div className={cn('col s6 m3', styles.countsBody)}>
      <div className={styles.centerDiv}>
        <span className={styles.totalNumber} >5,483</span><br />
        <span className={styles.totalNumberText}>ACTIVE FOOTBALL COACHES</span><br />
        <span>
          <div className={styles.underline} />
        </span>
      </div>
    </div>
    <div className={cn('col s6 m3', styles.countsBody)}>
      <div className={styles.centerDiv}>
        <span className={styles.totalNumber} >262 </span><br />
        <span className={styles.totalNumberText}>D1 FCS AND FBS SCHOOLS</span><br />
        <span>
          <div className={styles.underline} />
        </span>
      </div>
    </div>
  </div>
);

export default Totalcounts;



// WEBPACK FOOTER //
// ./src/components/TotalCounts/Totalcounts.js